/**
 * CSS-var overrides set on the `<HubTypographyScope>` wrapper. These map
 * AK design-system typography tokens onto values that reference the
 * `--hub-heading-font-family` / `--hub-paragraph-font-family` handles —
 * forcing every heading / body composite token to render with the admin's
 * picked font instead of the AK default.
 *
 * Sizes and line-heights use rem values matching the canonical AK source at
 * `platform/packages/design-system/tokens/src/artifacts/themes/atlassian-typography.tsx`.
 * The only difference from the AK source is the `font-family` segment, which
 * is replaced with the hub family CSS-var handle.
 *
 * Medium / Bold / xxsmall heading entries and weight variants for body are
 * included defensively (cost of a missing override is visible inconsistency;
 * cost of an unnecessary override is zero).
 */

export const HUB_HEADING_TOKEN_MAP: Record<string, string> = {
	'--ds-font-family-heading': 'var(--hub-heading-font-family)',
	'--ds-font-family-brand-heading': 'var(--hub-heading-font-family)',
	'--ds-font-heading-xxlarge': 'normal 653 2rem/2.25rem var(--hub-heading-font-family)',
	'--ds-font-heading-xlarge': 'normal 653 1.75rem/2rem var(--hub-heading-font-family)',
	'--ds-font-heading-large': 'normal 653 1.5rem/1.75rem var(--hub-heading-font-family)',
	'--ds-font-heading-medium': 'normal 653 1.25rem/1.5rem var(--hub-heading-font-family)',
	'--ds-font-heading-small': 'normal 653 1rem/1.25rem var(--hub-heading-font-family)',
	'--ds-font-heading-xsmall': 'normal 653 0.875rem/1.25rem var(--hub-heading-font-family)',
	'--ds-font-heading-xxsmall': 'normal 653 0.75rem/1rem var(--hub-heading-font-family)',
};

export const HUB_PARAGRAPH_TOKEN_MAP: Record<string, string> = {
	'--ds-font-family-body': 'var(--hub-paragraph-font-family)',
	'--ds-font-family-brand-body': 'var(--hub-paragraph-font-family)',
	'--ds-font-body-large': 'normal 400 1rem/1.5rem var(--hub-paragraph-font-family)',
	'--ds-font-body-large-medium': 'normal 500 1rem/1.5rem var(--hub-paragraph-font-family)',
	'--ds-font-body-large-bold': 'normal 700 1rem/1.5rem var(--hub-paragraph-font-family)',
	'--ds-font-body': 'normal 400 0.875rem/1.25rem var(--hub-paragraph-font-family)',
	'--ds-font-body-medium': 'normal 500 0.875rem/1.25rem var(--hub-paragraph-font-family)',
	'--ds-font-body-bold': 'normal 700 0.875rem/1.25rem var(--hub-paragraph-font-family)',
	'--ds-font-body-small': 'normal 400 0.75rem/1rem var(--hub-paragraph-font-family)',
	'--ds-font-body-small-medium': 'normal 500 0.75rem/1rem var(--hub-paragraph-font-family)',
	'--ds-font-body-small-bold': 'normal 700 0.75rem/1rem var(--hub-paragraph-font-family)',
	'--ds-font-body-UNSAFE_small': 'normal 400 0.75rem/1rem var(--hub-paragraph-font-family)',
};
